<template>
  <div class="address-picker">
    <van-actionsheet v-model="isShow" :close-on-click-overlay="false">
      <section class="select-wrap">
        <div class="header">
          <div class="back" @click="offBack"></div>
          <div>{{TLang('配送区域', 'address')}}</div>
          <div class="close" @click="offPopup"></div>
        </div>
        <div class="selected-wrap">
          <div
            class="select-item select-province"
            :class="currentShowType == 'province' ? 'select-item-active' : ''"
            @click="changeTab('province', selectedProvince, provinceList)"
          >
            <span class="select-choosed" v-if="selectedProvince.id">{{ selectedProvince.name }}</span>
            <span class="select-unChoose" v-else>{{ TLang('请选择', 'address') }}</span>
          </div>
          <div
            class="select-item select-city"
            v-if="selectedProvince.id"
            :class="currentShowType == 'city' ? 'select-item-active' : ''"
            @click="changeTab('city', selectedCity, cityList)"
          >
            <span class="select-choosed"  v-if="selectedCity.id">{{ selectedCity.name }}</span>
            <span class="select-unChoose" v-else>{{ TLang('请选择', 'address') }}</span>
          </div>
          <div
            class="select-item select-region"
            v-if="selectedCity.id"
            :class="currentShowType == 'region' ? 'select-item-active' : ''"
            @click="changeTab('region', selectedRegion, regionList)"
          >
            <span class="select-choosed"  v-if="selectedRegion.id">{{ selectedRegion.name }}</span>
            <span class="select-unChoose" v-else>{{ TLang('请选择', 'address') }}</span>
          </div>
          <div
            class="select-item select-street"
            v-if="selectedRegion.id"
            :class="currentShowType == 'street' ? 'select-item-active' : ''"
            @click="changeTab('street', selectedstreet, streetList)"
          >
            <span class="select-choosed"  v-if="selectedstreet.id">{{ selectedstreet.name }}</span>
            <span class="select-unChoose" v-else>{{ TLang('请选择', 'address') }}</span>
          </div>
        </div>
        <div class="scroll-wrap">
          <div class="show-list" v-if="showList && showList.length > 0">
            <div
              v-for="(item, index) in showList"
              :key="'' + index + item.id"
              :index="index"
              class="show-item"
              :class="currentInfo.id == item.id ? 'show-active' : ''"
              @click="saveCurInfo(item)"
              :id="'item'+ item.id"
            >
              <div class="show-name"><span>{{ item.name }}</span></div>
            </div>
          </div>
        </div>
      </section>
    </van-actionsheet>
  </div>
</template>

<script>
// import { setCatchAddress } from '../utils/locationApi/location';
import { setCatchAddress } from 'dflocationsdk';
import { getAllCityByProvince, getAllRegionByCity, getAllStreetByRegion } from '../assets/js/api';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    Cdata: Array, // 用户查询用户地址库里城市名的英文
    provinceList: Array,
  },
  data() {
    return {
      // selectedProvince: JSON.parse(sessionStorage.getItem('searchProvinceInfo')) || {} ,
      // selectedCity: JSON.parse(sessionStorage.getItem('searchCityInfo')) || {},
      // selectedRegion: JSON.parse(sessionStorage.getItem('searchRegionInfo')) || {},
      // selectedstreet: JSON.parse(sessionStorage.getItem('searchStreetInfo')) || {},
      selectedProvince: {},
      selectedCity: {},
      selectedRegion: {},
      selectedstreet: {},
      cityList: [],
      regionList:[],
      streetList: [],
      showList: this.provinceList,
      currentShowType: 'province',
      currentInfo: {},
    };
  },
  methods: {
    offPopup() {
      this.$emit("closePops");
    },
    offBack() {
      this.$emit("backPops");
    },
    changeHash(idName) {
      document.getElementById(idName).scrollIntoView();
    },
    // 切换四级地址TAB
    changeTab(type, info, list) {
      this.currentShowType = type;
      this.currentInfo = info;
      this.showList = list;
      // // 判断是否有选中数据
      // if (info && info.id) {
      //   this.$nextTick(function() {
      //     this.changeHash(`item${info.id}`)
      //   });
      // } else {
      //   this.$nextTick(function() {
      //     if (document.getElementsByClassName('show-item') && document.getElementsByClassName('show-item')[0]) {
      //       document.getElementsByClassName('show-item')[0].scrollIntoView();
      //     }
      //   });
      // }
    },
    // 选择四级地址
    async saveCurInfo(item) {
      this.currentInfo = item;
      switch (this.currentShowType) {
        case 'province':
          if (item.id == this.selectedProvince.id) {
            this.showList = this.cityList;
            this.currentShowType = 'city';
          } else {
            this.selectedProvince = item;
            this.selectedCity = {};
            this.cityList = [];
            this.selectedRegion = {};
            this.regionList = [];
            this.selectedstreet = {};
            this.streetList = [];
            // window.sessionStorage.setItem('searchProvinceInfo', JSON.stringify({...item, list: this.provinceList}))
            const res = await getAllCityByProvince({id: item.id})
            if (res.data.body) {
              this.cityList = res.data.body;
              this.showList = res.data.body;
              this.currentShowType = 'city';
            }
          }
          // this.$nextTick(function() {
          //   if (document.getElementsByClassName('show-item') && document.getElementsByClassName('show-item')[0]) {
          //     document.getElementsByClassName('show-item')[0].scrollIntoView();
          //   }
          // });
          break;
        case 'city':
          if (item.id == this.selectedCity.id) {
            this.showList = this.regionList;
            this.currentShowType = 'region';
          } else {
            this.selectedCity = item;
            this.selectedRegion = {};
            this.regionList = [];
            this.selectedstreet = {};
            this.streetList = [];
            // window.sessionStorage.setItem('searchCityInfo', JSON.stringify({...item, list: this.cityList}))
            const res = await getAllRegionByCity({id: item.id})
            if (res.data.body) {
              this.regionList = res.data.body;
              this.showList = res.data.body;
              this.currentShowType = 'region';
            }
          }
          // this.$nextTick(function() {
          //   if (document.getElementsByClassName('show-item') && document.getElementsByClassName('show-item')[0]) {
          //     document.getElementsByClassName('show-item')[0].scrollIntoView();
          //   }
          // });
          break;
        case 'region':
          if (item.id == this.selectedRegion.id) {
            this.showList = this.streetList;
            this.currentShowType = 'street';
          } else {
            this.selectedRegion = item;
            this.selectedstreet = {};
            this.streetList = [];
            // window.sessionStorage.setItem('searchRegionInfo', JSON.stringify({...item, list: this.regionList}))
            const res = await getAllStreetByRegion({id: item.id})
            if (res.data.body) {
              this.streetList = res.data.body;
              this.showList = res.data.body;
              this.currentShowType = 'street';
            }
          }
          // this.$nextTick(function() {
          //   if (document.getElementsByClassName('show-item') && document.getElementsByClassName('show-item')[0]) {
          //     document.getElementsByClassName('show-item')[0].scrollIntoView();
          //   }
          // });
          break;
        case 'street':
          if (item.id == this.selectedstreet.id) {
            this.offPopup();
          } else {
            this.selectedstreet = item;
            // window.sessionStorage.setItem('searchStreetInfo', JSON.stringify({...item, list: this.streetList}))
            setCatchAddress(
              this.selectedProvince.id,
              this.selectedProvince.name,
              this.selectedProvince.enName || this.selectedCity.name,
              this.selectedCity.id,
              this.selectedCity.name,
              this.selectedCity.enName || this.getCityEn(this.selectedCity.id, this.selectedCity.name),
              this.selectedRegion.id,
              this.selectedRegion.name,
              this.selectedRegion.enName || this.selectedRegion.name,
              item.id,
              item.name,
              item.enName || item.name,
              '',
            )
            this.$emit("handleReload");
          }
          break;
      }
    },
    // 获取城市英文
    getCityEn(id, name) {
      let n = name
      if (this.Cdata && this.Cdata.length > 0) {
        this.Cdata.forEach((ele) => {
          if (ele.cityId == id) {
            n = ele.pinyin
            return ele.pinyin;
          }
        })
      }
      return n
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.address-picker {
  .van-popup {
    border-radius: 12px * @375 12px * @375 0px * @375 0px * @375;
    // padding: 12px * @375;
    box-sizing: border-box;
    height: 85vh;
    overflow-y: hidden;
  }
  .van-actionsheet__content {
    position: relative;
  }
  // /deep/ .mint-indexsection-index {
  //   background: #fff;
  // }
  /deep/ .van-field__control {
    line-height: 24px * @375;
    font-size: 14px * @375;
  }
  /deep/ .en .van-cell__title span {
    font-family: system-ui, -apple-system, Arial, sans-serif;
  }
  .scroll-wrap {
    height: calc(85vh - 92px * @375);
    overflow-y: auto;
    box-sizing: border-box;
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
  }
  .select-wrap {
    // width: 100vw;
    // height: 100vh;
    background: #fff;
    text-align: left;
    .header {
      height: 55px * @375;
      text-align: center;
      position: relative;
      font-size: 16px * @375;
      font-weight: 400;
      color: #333333;
      line-height: 55px * @375;
      .back {
        position: absolute; 
        width: 24px * @375;
        height: 24px * @375;
        top: 18px * @375;
        left: 16px * @375;
        background: url("../assets/imgs/icon_blackBack.png") center center no-repeat;
        background-size: 100% auto;
      }
      .close {
        position: absolute;
        top: 15px * @375;
        right: 15px * @375;
        width: 18px * @375;
        height: 18px * @375;
        background: url('../assets/imgs/add_cart_close.png') center center no-repeat;
        background-size: 100% auto;
      }
    }
    .selected-wrap {
      padding: 0 15px * @375;
      box-sizing: border-box;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      .select-item {
        box-sizing: border-box;
        padding-bottom: 15px * @375;
        font-size: 14px * @375;
        font-weight: 400;
        color: #999999;
        line-height: 20px * @375;
        margin-right: 15px * @375;
        border-bottom: 2px * @375 solid transparent;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 75px * @375;
        &:last-child{
          margin-right: 0;
        }
        .select-choosed {
          color: #333;
        }
      }
      .select-item-active {
        border-bottom: 2px * @375 solid #3FA6FF;
      }
    }
    .show-list {
      padding: 15px * @375;
      padding-top: 0;
      padding-bottom: calc(40px * @375 + constant(safe-area-inset-bottom));
      padding-bottom: calc(40px * @375 + env(safe-area-inset-bottom));
      .show-item {
        padding-top: 16px * @375;
        // border: 2px * @375 solid transparent;
        // &:first-child{
        //   padding-top: 0;
        // }
        .show-name {
          font-size: 14px * @375;
          font-weight: 400;
          color: #333333;
          line-height: 20px * @375;
        }
      }
      .show-active {
        // border: 2px * @375 solid #3FA6FF;
        .show-name {
          color: #3FA6FF;
          background: url("../assets/imgs/icon_select_address.png") right center no-repeat;
          background-size: 18px * @375 auto;
        }
      }
    }
  }
}
</style>
